import * as React from "react";

/**
 * Hook for creating a value exactly once.
 * @param fn Function which created the value to return.
 * @returns Value created on the first render of the hook.
 */
export function useConstant<T>(fn: () => T): T {
  const ref = React.useRef<{ value: T }>();
  if (!ref.current) {
    ref.current = { value: fn() };
  }
  return ref.current.value;
}
